import { IAppContext } from '@agilepoint/wat';
import { AppLoader } from 'app-loader';
import { CoreApiClient } from 'modules/core/clients';
import React from 'react';
import { IApplicationConfig } from 'types';

interface IAppInitializerProps {
    appContext: IAppContext<IApplicationConfig>;
}

const defaultLocale = 'en-US';

export function AppInitializer(props: IAppInitializerProps) {
    const { appContext } = props;
    const [appInitialerInfo, setAppInitilizerInfo] = React.useState<{
        culture: string,
        loading: boolean
    }>({
        culture: defaultLocale,
        loading: true
    });

    const getCulture = React.useCallback(() => {
        const { configuration: { agilepoint: { userDetails: { userName } } }, client } = appContext;
        const apiClient = new CoreApiClient(client);
        return apiClient.getLoggedUserDetails(userName).then((r) => (r ? r.locale : defaultLocale));
    }, [appContext]);

    React.useEffect(() => {
        getCulture().then((res) => {
            setAppInitilizerInfo({
                culture: res,
                loading: false
            });
        })
            .catch(r => setAppInitilizerInfo({
                culture: defaultLocale,
                loading: false
            }));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (appInitialerInfo.loading) {
        return (
            <></>
        );
    }

    return (
        <AppLoader appContext={appContext} culture={appInitialerInfo.culture} />
    );
}
